import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { MergeUnknownEventMemberModel } from "../models/events/merge-unknown-event-member.model";

@Injectable({
    providedIn: 'root'
})
export class EventMemberService {

    constructor(private httpClient: HttpClient) {
    }

    public mergeUnknownEventMember(model: MergeUnknownEventMemberModel): Observable<void> {
        return this.httpClient.post<void>(
            Configuration.getApiBaseUrl() + "/event-member/merge-unknown-member", 
            model
        );
    }
}